// 空模块，用于在 web 环境下替代 electron 模块
module.exports = {};
